import Constants from 'expo-constants';

const extra = (Constants.expoConfig?.extra ?? {}) as {
  googleWebClientId?: string;
  googleIosUrlScheme?: string;
};

/**
 * Google OAuth (Firebase Auth).
 *
 * Firebase Console → Authentication → Sign-in method → Google → Web SDK configuration:
 * copy the Web client ID (…apps.googleusercontent.com). Required for Android, iOS, and web.
 *
 * iOS URL scheme: Firebase → Project settings → Your apps → iOS → REVERSED_CLIENT_ID
 * (e.g. com.googleusercontent.apps.123456789-abcdef).
 */
export const OAUTH_CONFIG = {
  googleWebClientId:
    process.env.EXPO_PUBLIC_GOOGLE_WEB_CLIENT_ID ??
    extra.googleWebClientId ??
    '',
  googleIosUrlScheme:
    process.env.EXPO_PUBLIC_GOOGLE_IOS_URL_SCHEME ??
    extra.googleIosUrlScheme ??
    '',
};

export const isGoogleSignInConfigured = (): boolean =>
  Boolean(OAUTH_CONFIG.googleWebClientId);
